import { retentionApi } from '~services/api/retention';
import { EnvType, getEnv } from '~utils/env';

let serviceWorkerSettings: { SW: ServiceWorkerRegistration } | undefined =
	undefined;

const standKey =
	'BFcAyCX0UUdFa0g5KYPHrHhoBXY4A6PdReRS15My9iVJrlc2bULCa2kWTbPlql9G1p2QAqPwVpgfqIqTP3_zLEM';
const prodKey =
	'BKtnawWLWS5H2AJkWJRrPaLxWxFPM1NTzz60reE7zDwnRhVMLSsJymM0sBJlhWyeY5hUmCGsvSlDEZ-rXT5tYow';

export const WebPushService = (dispatch: unknown) => {
	const registerService = async (userId: string) => {
		let subscription;
		try {
			subscription = await subscribeWorker();
		} catch {
			return;
		}
		if (!subscription) {
			return;
		}

		const key = base64Encode(subscription.getKey('p256dh'));
		const auth = base64Encode(subscription.getKey('auth'));

		const request = retentionApi.endpoints.updateAddresses.initiate({
			userId,
			webPushToken: {
				endpoint: subscription.endpoint,
				encryptionKey: key,
				authenticationKey: auth,
			},
		});
		// @ts-ignore
		void dispatch(request);
	};

	const subscribeWorker = async () => {
		const isLive = getEnv() === EnvType.Production;
		const serviceWorker = await navigator.serviceWorker.register(
			`/app/service-worker.js?isLive=${isLive.toString()}`
		);
		serviceWorkerSettings = Object.freeze({ SW: serviceWorker });
		const subscription = await serviceWorker?.pushManager?.getSubscription();
		if (subscription) {
			return subscription;
		}

		return await serviceWorker.pushManager
			.subscribe({
				userVisibleOnly: true,
				applicationServerKey: isLive ? prodKey : standKey,
			})
			.catch((e: Error) => {
				logErrorStack('Fail to subscribe', e);
			});
	};

	const unsubscribeWebPush = async () => {
		if (serviceWorkerSettings && serviceWorkerSettings.SW) {
			const serviceWorker = serviceWorkerSettings.SW;

			try {
				const subscription = await serviceWorker.pushManager.getSubscription();

				if (subscription) {
					await subscription.unsubscribe();
				}
			} catch (error) {
				logErrorStack('Fail on RT unsubscribe', error);
			}

			try {
				await serviceWorker.unregister();
			} catch (error) {
				logErrorStack('Fail on SW delete', error);
			}
		}
		try {
			void navigator.serviceWorker
				.getRegistrations()
				.then((registrations) =>
					registrations.map((registration) => registration.unregister())
				);
		} catch {}
	};

	const askPermission = (userId: string) => {
		if (!('Notification' in window)) {
			// eslint-disable-next-line no-console
			console.log('[WEB-PUSH]: no notifications functionality');
			return;
		}
		void Notification.requestPermission()
			.then((userPermission) => {
				// eslint-disable-next-line no-console
				console.log('[WEB-PUSH]: permission result', userPermission);
				if (userPermission === 'granted') {
					void registerService(userId);
				}
			})
			.catch((e) => {
				// eslint-disable-next-line no-console
				console.log('[WEB-PUSH]: permission error', e);
			});
	};

	const base64Encode = (arrayBuffer: ArrayBuffer | null) => {
		// @ts-ignore
		return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
	};

	const logErrorStack = (message: string, payload: unknown) => {
		// eslint-disable-next-line no-console
		console.error(`[WEB-PUSH]: ${message}`, payload);
	};

	return { askPermission, unsubscribeWebPush };
};

// export const WebPushService = new WebPush();
